export const API_USERS_HOST = "http://10.1.61.1:3003";
export const API_HOST = "https://backend.lettaiot.com:8000";
export const UI_HOST = "https://ui.lettaiot.com:8000";
export const KEYCLOAK_HOST = "https://login.lettaiot.com:8443";
export const KEYCLOAK_UITEST_HOST = "https://backend.lettaiot.com:8443";

export const TEST_UI = "https://backendtest.lettaiot.com:8000"
export const KEYCLOAK_TEST_UI = "https://logintest.lettaiot.com:8443";